var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 34,
    viewBox: "0 0 50 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 33,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 33,
    rx: 5.5,
    stroke: "#D0D5DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4476 22.4674H12.4883L10.2691 13.8741C10.1637 13.4788 9.94008 13.1293 9.6111 12.9646C8.79009 12.5507 7.88538 12.2213 6.89844 12.0552V11.7243H11.6658C12.3238 11.7243 12.8172 12.2213 12.8995 12.7985L14.0509 18.9971L17.0089 11.7243H19.886L15.4476 22.4674ZM21.5309 22.4674H18.736L21.0375 11.7243H23.8324L21.5309 22.4674ZM27.4483 14.7005C27.5305 14.1219 28.024 13.791 28.5997 13.791C29.5044 13.708 30.4899 13.8741 31.3124 14.2866L31.8059 11.9735C30.9834 11.6427 30.0787 11.4766 29.2577 11.4766C26.545 11.4766 24.5711 12.9646 24.5711 15.0299C24.5711 16.601 25.9693 17.426 26.9563 17.923C28.024 18.4185 28.4352 18.7494 28.353 19.2449C28.353 19.9882 27.5305 20.3191 26.7095 20.3191C25.7226 20.3191 24.7356 20.0713 23.8324 19.6574L23.3389 21.9719C24.3258 22.3844 25.3936 22.5505 26.3805 22.5505C29.4222 22.6321 31.3124 21.1455 31.3124 18.9141C31.3124 16.1041 27.4483 15.9394 27.4483 14.7005ZM41.0938 22.4674L38.8747 11.7243H36.491C35.9975 11.7243 35.504 12.0552 35.3395 12.5507L31.2301 22.4674H34.1073L34.6816 20.8977H38.2167L38.5457 22.4674H41.0938ZM36.9022 14.6174L37.7232 18.6663H35.4218L36.9022 14.6174Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.61cd2308e07271d99213c639390c7ab8.svg";
export { ForwardRef as ReactComponent };